import { Application, ApplicationStateMultipleTranslation, DisplayApplicationState } from '@witkac/kartamiejska-shared';
import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import ApplicationDetails from '@/views/application/Details.vue';
import Applications from '@/views/application/Index.vue';
import ApplicationList from '@/views/application/List.vue';

export const applicationRoute: RouteConfig = {
  path: 'applications',
  meta: { toolbarTitle: 'Wnioski' },
  name: 'applications',
  redirect: { name: 'applicationsByState', params: { state: DisplayApplicationState.SUBMITTED } },
  component: Applications,
  children: [
    {
      path: ':state',
      name: 'applicationsByState',
      component: ApplicationList,
      beforeEnter: (to, from, next) => {
        const state = to.params.state as DisplayApplicationState;
        store.commit('breadcrumbs/set', [
          { text: 'Wnioski', to: { name: 'applications' }, exact: true },
          {
            text: ApplicationStateMultipleTranslation[DisplayApplicationState[state]],
            disabled: true
          }
        ]);
        Promise.all([
          store.dispatch('application/list', { ...baseFilters(to), state }),
          store.dispatch('access/check', ['APPLICATION.GET'])
        ])
          .then(() => next())
          .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać listy wniosków.' }));
      }
    },
    {
      path: ':state/:applicationId(\\d+)',
      name: 'application',
      component: ApplicationDetails,
      beforeEnter: (to, from, next) => {
        const applicationId = parseInt(to.params.applicationId);

        store.commit('application/setId', applicationId);
        store
          .dispatch('application/get')
          .then(application => {
            const state = (application.state as DisplayApplicationState) || DisplayApplicationState.SUBMITTED;
            const stateTranslation: string = ApplicationStateMultipleTranslation[state];
            store.commit('breadcrumbs/set', [
              { text: 'Wnioski', to: { name: 'applications' }, exact: true },
              {
                text: stateTranslation,
                to: { name: 'applicationsByState', params: { state: application.state } },
                exact: true
              },
              {
                text: `#${application.id} ${application.firstName} ${application.lastName}`,
                to: { name: 'application', params: { id: applicationId } }
              }
            ]);
            const isNewApplication = application.type === 'NEW';
            return store.dispatch(
              'settings/settingFind',
              isNewApplication ? 'APPLICATION_NEW_GROUPS_FORM' : 'APPLICATION_EXTEND_GROUPS_FORM'
            );
          })
          .then(() => next())
          .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać danych wniosku' }));
      },
      meta: { toolbarTitle: 'Wniosek' }
    }
  ]
};
